import React from "react";

let SERVER_HOST = "http://localhost:8000/engine.php";
// let SERVER_HOST = 'https://cocktail-4.e-menu.in.ua/shef/backend/engine.php';
if (process.env.NODE_ENV === "production")
    SERVER_HOST = "/shef/backend/engine.php";

export const dataContext = React.createContext();

const THEME_0 = {
    "--background": `no-repeat center center / cover url(${process.env.PUBLIC_URL}/bg_1.svg), linear-gradient(340deg, #b3d8d8 -27.16%, #a2d6d7 100%)`,
    "--navbar-bg-color": "#ABD7D8",
    "--navbar-tx-color": "#000000",

    "--item-bg-color": "#ffffff44",
    "--item-border-color": "#ffffff00",
    "--item-border-radius": "1.75rem",

    "--main-btn-color": "#6c757d",
    "--main-btn-border-color": "#6c757d",
    "--main-btn-border-radius": "2rem",
    "--main-btn-tx-color": "#ffffff",
    "--main-btn-hover-color": "#60686f",
    "--main-btn-tx-hover-color": "#ffffff",

    "--red-btn-color": "#b5706f",
    "--red-btn-border-color": "#b5706f",
    "--red-btn-border-radius": "2rem",
    "--red-btn-tx-color": "#ffffff",
    "--red-btn-hover-color": "#9e5958",
    "--red-btn-tx-hover-color": "#ffffff",
};

export { SERVER_HOST, THEME_0 };
